import { render } from "./ModelPerformanceSummary.vue?vue&type=template&id=c9d4c616"
import script from "./ModelPerformanceSummary.vue?vue&type=script&lang=js"
export * from "./ModelPerformanceSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__